import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, withRouter } from "react-router-dom";
import * as RoutePath from "../../shared/utils/routeLink";
import * as Variable from "../../shared/utils/variables";
import * as ActionTypes from "../../store/actions/actionTypes";
import { toast } from "react-toastify";
import "./ScholarshipDetail.scss";
import Image from "../../shared/component/UI/Image";
import {
	BuildingIcon,
	CaretDown,
	// CheckCircle,
	HeartIconFilled,
	HeartIconOutline,
	HourglassIcon,
} from "../../shared/component/svg/Icons";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import LoadingComponent from "../../shared/component/LoadingComponent/LoadingComponent";
import moment from "moment";
import { Accordion } from "react-bootstrap";
import makeRequest from "../../shared/utils/request";
import { generateRequestOptions } from "../../shared/utils/apiEndPoints";
import { Helmet } from "react-helmet";

const SCHOLARSHIP_GIVER_ENUM = {
	government: Variable.GOVERNMENT,
	college: Variable.COLLEGE,
	private: Variable.ORGANIZATION,
	international: Variable.INTERNATIONAL,
};
const DESTINATION_ENUM = {
	domestic: Variable.DOMESTIC,
	abroad: Variable.INTERNATIONAL_DESTINATION,
};
const ACCORDION_DATA = [
	{ id: "documents_required", name: Variable.DOCUMENTS_REQUIRED },
	{ id: "special_requirements", name: Variable.SPECIAL_REQS },
	{ id: "level_of_competition", name: Variable.LEVEL_OF_COMPS },
	{ id: "selection_period", name: Variable.SELECTION_PERIOD },
	{ id: "checking_announcement", name: Variable.CHECKING_ANNOUNCEMENT },
	{ id: "other_explanation", name: Variable.OTHER_EXPLANATION },
];

const MajorDetail = ({ ENV_NAME, isAuthenticated, fetchingAddRemoveFavorites, ...props }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [scholarshipData, setScholarshipData] = useState(null);
	const [openedAccordion, setOpenedAccordion] = useState([]);
	let location = useLocation();

	// Get the id of a scholarship
	// If they don't have any scholarship, redirect to the home page
	useEffect(() => {
		if (location?.pathname?.includes(RoutePath.SCHOLARSHIP_DETAIL)) {
			let url = location?.pathname;
			let id = url?.substring(url.lastIndexOf("/") + 1);
			if (id !== RoutePath.SCHOLARSHIP_DETAIL && !isNaN(id)) {
				getMajorDetails(id);
			} else {
				toast.error(Variable.SCHOLARSHIP_NOT_FOUND[ENV_NAME]);
				props.history.push(RoutePath.ROOT);
			}
		}
	}, [location]); // eslint-disable-line

	// Get scholarship details
	// If API error, redirect to the home page
	const getMajorDetails = async (id) => {
		setIsLoading(true);
		let res = await makeRequest(generateRequestOptions("scholarshipDetail", { urlParams: id + "/" }));
		if (res.code === 200) {
			setScholarshipData({...res.data,
				scholarship_timeline: res.data.scholarship_timeline.sort((a,b) => a.id - b.id)
			});
		} else {
			toast.error(Variable.SCHOLARSHIP_NOT_FOUND[ENV_NAME]);
			props.history.push(RoutePath.ROOT);
		}
		setIsLoading(false);
	};

	return (
		<div className="scholarship-detail">
			{scholarshipData?.title && (
				<Helmet>
					<title>
						Direktori Kampus Terbaik di Indonesia - Portal Sekolah - {scholarshipData?.title || "-"}
					</title>
				</Helmet>
			)}
			{isLoading ? (
				<LoadingComponent />
			) : (
				<>
					<Image className="full-width-banner" src={scholarshipData?.banner_image} />
					<div className="container scholarship-header">
						<div className="d-flex-desktop justify-content-between align-items-center">
							<div className="d-flex align-items-center">
								<Image src={scholarshipData?.scholarship_icon} className="scholarship-logo" />
								<h2 className="text-label-dark-gray-2 mb-0">
									<strong>{scholarshipData?.title || "-"}</strong>
								</h2>
							</div>
							<button
								className="btn fav-button me-sm"
								onClick={() => {
									if (fetchingAddRemoveFavorites) return;
									if (isAuthenticated) {
										// call API
										props.addRemoveFavorite(
											scholarshipData?.is_favourite ? "remove" : "add",
											"career",
											scholarshipData?.is_favourite
												? scholarshipData?.fav_obj_id
												: scholarshipData?.id,
											(res) => {
												if (scholarshipData?.is_favourite) {
													setScholarshipData((p) => ({
														...p,
														fav_obj_id: null,
														is_favourite: false,
													}));
												} else {
													setScholarshipData((p) => ({
														...p,
														fav_obj_id: res?.data?.id,
														is_favourite: true,
													}));
												}
											}
										);
									} else {
										props.openLoginModal();
									}
								}}
							>
								{scholarshipData?.is_favourite ? (
									<>
										<HeartIconFilled className="me-xs" width="2rem" height="2rem" fill="#F24822" />
										{Variable.REMOVE_FROM_FAVORITES[ENV_NAME]}
									</>
								) : (
									<>
										<HeartIconOutline
											className="me-xs"
											width="2rem"
											height="2rem"
											stroke="#F24822"
										/>
										{Variable.ADD_TO_FAVORITES[ENV_NAME]}
									</>
								)}
							</button>
						</div>
						<div className="divider" />
						<div className="d-flex-desktop text-center">
							<div className="w-100 px-sm">
								<div className="text-label-dark-gray mb-sm">{Variable.SCHOLARSHIP_GIVER[ENV_NAME]}</div>
								<div className="flex-all-center">
									<h4 className="text-label-dark-gray-2 my-xxs">
										<strong>
											{SCHOLARSHIP_GIVER_ENUM?.[scholarshipData?.scholarship_giver]?.[ENV_NAME] ||
												scholarshipData?.scholarship_giver ||
												"-"}
										</strong>
									</h4>
								</div>
							</div>
							<div className="w-100 px-sm">
								<div className="text-label-dark-gray mb-sm">
									{Variable.REGISTRATION_PERIOD[ENV_NAME]}
								</div>
								<div className="flex-all-center">
									<HourglassIcon width="2.4rem" height="2.4rem" stroke="#FEAF43" className="me-xxs" />
									<h4 className="text-label-dark-gray-2 my-xxs">
										{`${Variable.UNTIL[ENV_NAME]} `}
										<strong>
											{scholarshipData?.registration_period
												? moment(scholarshipData?.registration_period).format("ll")
												: "-"}
										</strong>
									</h4>
								</div>
							</div>
							<div className="w-100 px-sm">
								<div className="text-label-dark-gray mb-sm">{Variable.DESTINATION[ENV_NAME]}</div>
								<div className="flex-all-center">
									<BuildingIcon width="2.4rem" height="2.4rem" stroke="#193560" className="me-xxs" />
									<h4 className="text-label-dark-gray-2 my-xxs">
										<strong>
											{DESTINATION_ENUM?.[scholarshipData?.campus_destination]?.[ENV_NAME] ||
												scholarshipData?.campus_destination ||
												"-"}
										</strong>
									</h4>
								</div>
							</div>
						</div>
					</div>
					<section className="container detail-section">
						<h2 className="header text-center">{Variable.SCHOLARSHIP_DESCRIPTION[`${scholarshipData?.label_language}g`]}</h2>
						<div
							className="force-styling-wysiwyg"
							dangerouslySetInnerHTML={{
								__html: scholarshipData?.scholarship_description || "",
							}}
						/>
					</section>
					<section className="scholarship-info detail-section">
						<h2 className="header text-center">{Variable.IMPORTANT_INFO[`${scholarshipData?.label_language}g`]}</h2>
						{ACCORDION_DATA?.map((i, idx) => {
							let opened = openedAccordion?.some((j) => j === idx);
							if (!scholarshipData?.[i?.id]) return <></>;
							return (
								<Accordion defaultActiveKey="0" className="scholarship-info-accordion" key={idx}>
									<Accordion.Item eventKey="0">
										<Accordion.Button
											as="div"
											eventKey="0"
											className="sa-header cursorPointer"
											onClick={() => {
												if (opened) {
													setOpenedAccordion((p) => p.filter((j) => j !== idx));
												} else {
													setOpenedAccordion((p) => [...p, idx]);
												}
											}}
										>
											<>
												<h3 className="mb-0">
													<strong>{i?.name?.[`${scholarshipData?.label_language}g`] || ""}</strong>
												</h3>
												<div className={`arrow ${opened ? "open" : ""}`}>
													<CaretDown stroke="#193560" className="ms-auto" />
												</div>
											</>
										</Accordion.Button>
										<Accordion.Collapse eventKey="0" className="sa-content">
											<div
												className="w-100 overflow-auto force-styling-wysiwyg"
												dangerouslySetInnerHTML={{
													__html: scholarshipData?.[i?.id] || "",
												}}
											/>
										</Accordion.Collapse>
									</Accordion.Item>
								</Accordion>
							);
						})}
					</section>
					<section className="benefit-cont detail-section">
						<h2 className="header text-center">{Variable.WHAT_BENEFIT[`${scholarshipData?.label_language}g`]}</h2>
						<div className="benefit-item-cont">
							<div className="benefit-item">
								{/* <CheckCircle width="3rem" height="3rem" fill="#193560" className="me-sm" />
									{i} */}
								<div
									className="force-styling-wysiwyg"
									dangerouslySetInnerHTML={{
										__html: scholarshipData?.benefit || "",
									}}
								/>
							</div>
						</div>
					</section>
					{scholarshipData?.scholarship_timeline?.length > 0 && (
						<section className="container detail-section">
							<h2 className="header text-center">{Variable.REGISTRATION_TIMELINE[`${scholarshipData?.label_language}g`]}</h2>
							<div className="flex-all-center">
								<div className="regist-timeline-cont">
									{scholarshipData?.scholarship_timeline?.map((i, idx) => (
										<div className="rt-item" key={"rt-" + i?.id}>
											<div className="rt-point" />
											<div
												className="rt-desc"
												style={{ "--width": `${Math.min(20, 3 + idx * 2)}rem` }}
											>
												<div className="rt-line"></div>
												<div className="rt-header">{i?.title}</div>
												<div
													className="rt-subtitle"
													dangerouslySetInnerHTML={{
														__html: i?.subtitle || "-",
													}}
												/>
											</div>
										</div>
									))}
								</div>
							</div>
						</section>
					)}
				</>
			)}
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.auth.isAuthenticated,
		ENV_NAME: state.auth.selectedEnvironment || "bhs",
		fetchingAddRemoveFavorites: state.auth.fetchingAddRemoveFavorites,
	};
};

const mapStateToDispatch = (dispatch) => {
	return {
		openLoginModal: () =>
			dispatch({
				type: ActionTypes.OPEN_LOGIN_MODAL,
			}),
		addRemoveFavorite: (action, type, id, onSuccess = null, onFail = null) =>
			dispatch({
				type: ActionTypes.ADD_REMOVE_FAVORITE,
				data: { action, type, id },
				onSuccess,
				onFail,
			}),
	};
};

export default connect(mapStateToProps, mapStateToDispatch)(withRouter(MajorDetail));
